import { render, staticRenderFns } from "./HightlightTagGroup.vue?vue&type=template&id=199509b0&"
import script from "./HightlightTagGroup.vue?vue&type=script&lang=js&"
export * from "./HightlightTagGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports